import React from "react";

import { Button } from "react-bootstrap";
import {
  ApproveIcon,
  CancelIcon,
  UnApproveIcon,
} from "../gui_components/Icons.js";

export class PreProductionModuleToolBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: this.props.pageTitle,
      isShowApproveButton: this.props.isShowApproveButton,
      isShowCancelButton: this.props.isShowCancelButton,
    };
  }
  componentDidMount() {
    //
  }

  componentDidUpdate() {
    //
  }
  approvePreProduction = (e) => {
    if (e.detail === 1) this.props.approvePreProduction();
  };
  unApprovePreProduction = (e) => {
    if (e.detail === 1) this.props.unApprovePreProduction();
  };
  cancelPreProduction = (e) => {
    if (e.detail === 1) this.props.cancelPreProduction();
  };
  submitPreProduction = (e) => {
    if (e.detail === 1) this.props.submitPreProduction();
  };
  reSubmitPreProduction = (e) => {
    if (e.detail === 1) this.props.reSubmitPreProduction();
  };
  finishPreProduction = (e) => {
    if (e.detail === 1) this.props.finishPreProduction();
  };
  render() {
    return (
      <>
        {this.props.isShowApproveButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.approvePreProduction(e)}
          >
            <ApproveIcon />
            Approve
          </Button>
        )}
        {this.props.isShowUnApproveButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.unApprovePreProduction(e)}
          >
            <UnApproveIcon />
            UnApprove
          </Button>
        )}
        {this.props.isShowCancelButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.cancelPreProduction(e)}
          >
            <CancelIcon />
            Cancel
          </Button>
        )}
        {this.props.isShowSubmitButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.submitPreProduction(e)}
          >
            Submit
          </Button>
        )}
        {this.props.isShowReSubmitButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.reSubmitPreProduction(e)}
          >
            ReSubmit
          </Button>
        )}
        {this.props.isShowFinishButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.finishPreProduction(e)}
          >
            Finish
          </Button>
        )}
      </>
    );
  }
}
